import React from "react"
import ButtonTemplate from "./ButtonTemplate"

export const widgetPrimaryButtonPrototype = [
    "buttonicons",
    {
        key: "size",
        type: "SELECT",
        label: "Größe",
        size: 6,
        options: [
            {
                value: "medium",
                label: "Normal (100)",
            },
            {
                value: "small",
                label: "Klein (50)",
            },
        ],
    },
    {
        key: "error",
        type: "YESNO",
        label: "Error",
        size: 6,
    },
]

const PrimaryButtonWidget = ({widget, value, payload, triggerAction}) => {
    const {size = "medium", error = false} = widget
    return (
        <ButtonTemplate
            color={error ? "error" : ""}
            size={size}
            buttonText={widget.text}
            actionType={widget.action}
            startIcon={widget.startIcon}
            endIcon={widget.endIcon}
            disabled={widget.disabled}
            payload={payload ?? value}
            widget={widget}
            variant="primary"
            triggerAction={triggerAction}
            onClick={widget.onClick}
        />
    )
}

export default PrimaryButtonWidget
